export function ChangeSourceIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M1.57234 7.41071C1.25517 7.41071 1 7.67344 1 8C1 8.32656 1.25517 8.58929 1.57234 8.58929H8.20438L7.4651 9.35045C7.24093 9.58125 7.24093 9.95446 7.4651 10.1828C7.68927 10.4112 8.05175 10.4136 8.27354 10.1828L9.99057 8.41495C10.2147 8.18415 10.2147 7.81094 9.99057 7.58259L8.27354 5.81473C8.04937 5.58393 7.68688 5.58393 7.4651 5.81473C7.24332 6.04553 7.24093 6.41875 7.4651 6.6471L8.20438 7.40826H1.57234V7.41071ZM2.52625 12.3214C2.31639 12.3214 2.14469 12.1446 2.14469 11.9286V10.9464C2.14469 10.6199 1.88952 10.3571 1.57234 10.3571C1.25517 10.3571 1 10.6199 1 10.9464V11.9286C1 12.7953 1.68443 13.5 2.52625 13.5H13.4737C14.3156 13.5 15 12.7953 15 11.9286V4.07143C15 3.20469 14.3156 2.5 13.4737 2.5L2.52625 2.5C1.68443 2.5 1 3.20469 1 4.07143V5.05357C1 5.38013 1.25517 5.64286 1.57234 5.64286C1.88952 5.64286 2.14469 5.38013 2.14469 5.05357V4.07143C2.14469 3.85536 2.31639 3.67857 2.52625 3.67857L13.4737 3.67857C13.6836 3.67857 13.8553 3.85536 13.8553 4.07143V11.9286C13.8553 12.1446 13.6836 12.3214 13.4737 12.3214L2.52625 12.3214Z"
        fill="var(--foreground-default, #101010)"
      />
    </svg>
  );
}
